import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { CreateAdvertForm } from "../components";

export const CreateAdvert = () => {
  return (
    <ContentLayout title="Create new advert" showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only Merchant can view this.</div>}
            allowedRoles={[ROLES.MERCHANT]}
          >
            <CreateAdvertForm />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
